import React, { FC } from 'react';
import { Section } from '../../layout/Section';
import { Grid } from '../../layout/Grid';
import { Layout } from '../../layout/Layout';
import { HeaderImage } from './PostHeader.styles';
import PageHeaderModule from '../PageHeaderModule';
import { ResponsiveImageProps } from '../../components/ResponsiveImage';
import Spacer from '../../components/Spacer';
import { useCategories } from '../../../old/storyblok/categories-context';
import { useTags } from '../../../old/storyblok/tags-context';
import { useAuthors } from '../../../old/storyblok/authors-context';

export type PostHeaderProps = ResponsiveImageProps & {
  title?: string;
  tags?: string[];
  categories?: string[];
  authors?: string[];
  hideHeroImage?: boolean;
  hideAuthor?: boolean;
};

const PostHeaderModule: FC<PostHeaderProps> = ({
  alt = 'header image',
  title,
  mobile,
  tablet,
  desktop,
  tags,
  categories,
  authors,
  hideHeroImage = false,
  hideAuthor = false,
}) => {
  const allCategories = useCategories();
  const selectedCategories = allCategories
    .filter((category) => categories?.includes(category.uuid))
    .map((category) => ({
      ...category,
      full_slug: category.full_slug.replace(`${category.slug}/`, ''),
    }));

  const allTags = useTags();
  const selectedTags = allTags.filter((tag) => tags?.includes(tag.uuid));

  const allAuthors = useAuthors();
  const selectedAuthors = allAuthors.filter((author) =>
    authors?.includes(author.uuid)
  );

  const hasImage = !hideHeroImage && mobile && tablet && desktop;

  return (
    <React.Fragment>
      <Spacer className={`fill-height ${hasImage ? 'small' : ''}`}>
        <PageHeaderModule
          title={title}
          tags={[...selectedTags, ...selectedCategories]}
          authors={!hideAuthor ? selectedAuthors : undefined}
          variant="tags"
        />
      </Spacer>
      {hasImage && (
        <Spacer className="super-small">
          <Section>
            <Layout>
              <Grid>
                <HeaderImage
                  mobile={mobile}
                  tablet={tablet}
                  desktop={desktop}
                  alt={alt}
                />
              </Grid>
            </Layout>
          </Section>
        </Spacer>
      )}
    </React.Fragment>
  );
};

export default PostHeaderModule;
